import { query } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { FilterSettingsModel, IFilter, ToolbarItems, GridComponent, GroupSettingsModel, IFilterUI, RowDataBoundEventArgs, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, DataUtil, Query } from '@syncfusion/ej2-data';
import { BsModalService } from 'ngx-bootstrap';
// import { WoocommerceOrderService, WoocommerceProductsService } from 'ngx-wooapi';
import { Observable } from 'rxjs';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { LegalDateTimeService } from 'src/app/services/legal-datetime.service';
import { MysqlService } from 'src/app/services/mysql.service';
//checkbox selection options
import { SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import * as c3 from 'c3';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import { ChartComponent, DateTimeCategory, DateTimeService, IPointEventArgs } from '@syncfusion/ej2-angular-charts';

@Component({
  selector: 'app-subject-activity-log-graph-widget',
  templateUrl: './subject-activity-log-graph-widget.component.html',
  styleUrls: ['./subject-activity-log-graph-widget.component.scss'],
  providers: [DateTimeService ]
})
export class SubjectActivityLogGraphWidgetComponent implements OnInit {



// Loadash Example
rating = '';
movieExist: boolean | undefined;
movieNotExist: boolean | undefined;

movies = [
  { name: 'Batman Begins', rating: 8.2 },
  { name: 'Insomnia', rating: 7.1 },
  { name: 'Doodlebug', rating: 7.1 },
  { name: 'Test', rating: 2 }
];

names = ['Angular', 'Ionic', 'React', 'Vue', 'Fluter'];
moviesByRating: any;
removeName: any;
sortedNums = [11, 13, 21, 3, 3, 15, 18, 8, 13];
// ...


  @Input() brand_id?: Observable<any[]>;
  @Input() job_status_code?: Observable<any[]>;
  @Input() assigned_agent?: Observable<any[]>;  // single agent brand_id lookup

  @Input() job_id?: Observable<any[]>;
  @Input() subject_id?: Observable<any[]>;

     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes. // Base set to Job_ID
     @Input() item_data?:any; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id

     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = null;
     @Input() item_brand_id? = null;
     @Input() item_subject_id? = null;
     @Input() item_subject_number? = '';

     @Input() show_buttons? = 'no'; // yes | no
     @Input() item_title? = '';
     @Input() widget_size? = 'search-results'; // search-results | live-orders 


     public data: DataManager;
     public data_subjects: DataManager;
     public pageSettings: Object;
     public pageOptions = { pageSize: 100 }; 
     public filterOptions: FilterSettingsModel;
     public filterOptions_2022: FilterSettingsModel;
     public formatOptions: Object;
     public filter : IFilter;
     public toolbarOptions: ToolbarItems[] | object;
     @ViewChild('grid')
     public grid: GridComponent;
     public groupOptions: GroupSettingsModel;
     public templateOptionsDate: IFilterUI;
     public elem1: HTMLElement;
     public datePickerObj: DatePicker;


     //checkbox selection options
     public selectionOptions: SelectionSettingsModel;


     subjects_urgent: any;
     formatoptions: { type: string; format: string; };
     dateFormat: string;
     sortOptions: { columns: { field: string; direction: string; }[]; };
  
     today = new Date(); // this date worked to compare dates with ZISo date format in database.
     today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
     action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
     action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison

  woo_products: any;
  sessionUserId: any;
  sessionUsername: any;
  all_router_details: string;
  sessionBrandId: any;
  initialPage: { pageSize: number; };
  woo_products_object: any;
  public page_collection = [];
  woo_orders: any;
  sessionUserName: string;
  sessionUserLevel: number;
  sessionUserFullName: string;
  sessionUserFirstName: string;
  search_results: any;

  // brand_wordpress_URL = this.gfunc.brand_wordpress_URL;
  productSlug: any;
  // 15-ways-led-soldering-practice-board-zy-tp1801
  variationSelected: string;
  params: object = {}
  woocommerce: any;
  woo_ppsactions: any;
  woo_ppsactions_count: any;
  selectedrecords: object[];
  already_checked_search_results: any;
  model: any;
  sent_model: any;
  get_latest_action_ist_id: any;
  action_lists: any;
  action_lists_table: any;
  chosenActionListData: any;
  searchOptions: {};
  action_list_today: any;
  chosenActionListID: any;
  action_list_today_ID: any;
  modalRef: any;
  total_ebay_orders: any;
  total_orders_dollars: any;

  public items: object[];
  new_val: any;
  sent_items_totals_array: any;
  total_cp_items: any;
  total_items: any;
  total_mail_items: any;
  total_checkout_mail_items: any;
  total_shipping_dollars: number;
  total_checkout_mail_sendle_items: any;
  total_checkout_mail_auspost_items: any;
  total_checkout_mail_local_pickup_items: any;
  total_checkout_mail_wf_dhl_shipping_items: any;
  total_cp_items_completed: any;
  total_mail_items_completed: any;
  total_completed_items: any;
  total_completed_items_percentage: any;
  total_checkout_mail_sendle_items_completed: any;
  total_checkout_mail_items_completed: any;
  total_checkout_mail_auspost_items_completed: any;
  total_checkout_mail_local_pickup_items_completed: any;
  total_checkout_mail_wf_dhl_shipping_items_completed: any;
  total_cp_items_completed_percentage: number;
  total_mail_items_completed_percentage: number;
  total_checkout_mail_items_completed_percentage: number;
  total_checkout_mail_wf_fedex_woocommerce_shipping_items: any;
  total_checkout_mail_wf_fedex_woocommerce_shipping_completed: any;
  woo_page: number;
  woo_per_page: number;
  request_query: {
    context?: string;
    page?: number;
    per_page?: number;
    search?: string;
    after?: string;
    before?: string;
    exclude?: Array<any>;
    include?: Array<any>;
    offset?: number;
    // order?: ProductOrder;
    // orderby?: ProductOrderBy | string;
    orderby?: "id";
  
    parent?: Array<string>;
    parent_exclude?: Array<string>;
    slug?: string;
    status?: any;
    type?: string;
    sku?: string;
    featured?: boolean;
    category?: string;
    tag?: string;
    shipping_class?: string;
    attribute?: string;
    attribute_term?: string;
    tax_class?: string;
    in_stock?: boolean;
    on_sale?: boolean;
    min_price?: string;
    max_price?: string;
  
}
  total_profit_dollars: number;
  user_login_count: any;
  user_logout: any[];
  user_logout_count: number;
  user_forced_logout_ON: any[];
  user_forced_logout_ON_count: number;
  user_forced_logout_OFF: any[];
  user_forced_logout_OFF_count: number;
  system_log_types: any;
  log_types_mapped_numbers: any[];
  log_types_mapped_labels: any[];
  title: string;
  graph_data: Object[];
  chartData_client: { log_type_name: string; sum: number; color: string; }[];
  chartData_agent: { log_type_name: string; sum: number; color: string; }[];
  chartData_staff: { log_type_name: string; sum: number; color: string; }[];
  Chart2_users_data: any;
  search_results_START: any;
  search_results_clone: any;
  search_results_clone_START: any;
  Chart2_title: string;
  Chart3_title: string;
  Chart3_marker: { visible: boolean; width: number; height: number; shape: string; };
  Chart3_tooltip: { enable: boolean; template: any; };
  Chart3_tooltipTemplate: any;
  Chart3_all_data: { log_type_name: any; sum: any; color: string; created_date: Date; }[];

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }



  //syncfusion charts
  @ViewChild('chart')
  public chart: ChartComponent;
  public primaryXAxis: Object;
public chartData: Object[];
public marker: Object;
public tooltip: Object;
public Chart2_marker: Object;
public Chart2_tooltip: Object;

public primaryYAxis: Object;
public cornerRadius: Object;
public chartArea: Object;
public animation: Object;
public pointColorMapping: string;
public pointClick(args: IPointEventArgs): void {
  document.getElementById("lbl").innerText = "Type : "+ args.point.x + "\nSum : "+ args.point.y  + "\nY : "+ args.series.name;
};
public pointClick_meta(args: IPointEventArgs): void {
  document.getElementById("lbl_meta").innerText = "Type : "+ args.point.x + "\nSum : "+ args.point.y  + "\nY : "+ args.series.name;
};

primaryXAxis_DateTimeCategory = {
  // valueType: 'DateTimeCategory'
  // valueType: 'Category'
  valueType: 'DateTime'
  
};

public tooltipTemplate: string =
"<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";

public Chart2_tooltipTemplate: string =
"<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";




  // chart: c3.ChartAPI; -- Disable if using syncfusion charts
        // @ViewChild('chart') chart: c3.ChartAPI;
        chart_guage: c3.ChartAPI; // @ViewChild('chart_guage') 



         // toggle elements
        //  isShow = true;
        isShow_chart1 = false;
        isShow_chart2 = false;

        isShow_chart1_meta = false;
        isShow_chart2_meta = false; // user investigation as default
        isShow_chart3_meta = true; // user investigation as default

  constructor( 
    // private productService: WoocommerceProductsService,
    // private orderService: WoocommerceOrderService,
    private http: HttpClient, private router: Router,
      private route: ActivatedRoute, private _demoService: DemoService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public toastr: HotToastService,
     vcr: ViewContainerRef,
     private _mysqlService: MysqlService,
     public legalDate: LegalDateTimeService) {

  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

          // need to add this as routes does not work globally
          this.all_router_details = this.router.url;
          this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

          // Grid Options
          // this.toolbarOptions = [];
          // Setup Grid
          this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
          tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
          ];
          // this.toolbar = [
          // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];


          this.initialPage = { pageSize: 100 };
          this.filterOptions = {
          type: 'Menu'
          };

          // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
          this.groupOptions = { }; // sets auto grouping for the grid

          this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
          this.dateFormat = 'dd/MM/yyyy hh:mm a';

          // this.filter = { params: { format: this.dateFormat } };
          // this.sortOptions = { columns: [ ] };

          //checkbox selection options
          // this.selectionOptions = { checkboxMode: 'ResetOnRowClick'}; // type: 'Multiple', mode: 'Both
          this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 

          this.searchOptions = {  };
          // this.grid.searchSettings.key = '';

          

          // load some custom ngx-woo api search options
          for(let i = 1; i<=99 ; i++) {
          this.page_collection.push(`${i}`);
          }

      // this.generateChart();

      }




      ngAfterViewInit() {
      // this.chart = c3.generate({
      //   bindto: '#chart',
      //       data: {
      //           columns: [
      //               ['data1', 30, 200, 100, 400, 150, 250],
      //               ['data2', 50, 20, 10, 40, 15, 25]
      //           ]
      //       }
      //   });
      // this.generateChart();

          // Generate Percentages Complete Guages -- this is a must to run and load the data for the guages in the inculed component.
              // this.loadCompletedItemsPercentage(this.total_completed_items_percentage, 'chart_guage', 'Total Complete', '180');
              // this.loadCompletedItemsPercentage(this.total_cp_items_completed_percentage, 'total_cp_items_completed', 'CP Completed', '120');
              //  this.loadCompletedItemsPercentage(this.total_mail_items_completed_percentage, 'total_mail_items_completed', 'MAIL Completed', '120');
              //  this.loadCompletedItemsPercentage(this.total_checkout_mail_items_completed_percentage, 'total_checkout_mail_items_completed', 'Woo Checkout Completed', '120');


      }
    



       // check for changes. to load data.
       ngOnChanges(changes) {

     this.getSystemLogTypes();


     

this.woo_orders = this.item_data; // sets the data regardless.

        if (changes.item_id) {
          // deal with asynchronous Observable result
          this.item_id = changes.item_id.currentValue;
        }


        if (changes.item_data) {
          // deal with asynchronous Observable result
          // this.getJob(this.job_id);
        // console.log('On changes Sent Action List Id:' + this.action_list_id);
        // this.generateChart();

          // this commnad dynamically loads data int the fhart
        // this.chart.load({
        //   columns: [
        //     ['data4', 300, 100, 250, 150, 300, 150, 500],
        //     ['data5', 100, 200, 150, 50, 100, 250]
        //   ]
        // });

   

        this.woo_orders = changes.item_data.currentValue;

                          // code for dashboard
                        if (this.woo_orders == "[]"){

                            this.woo_page = 1; // sets the default page to load is one
                          this.woo_per_page = 100;

                          if(this.woo_page == 1){
                            this.request_query = {
                              // page: this.woo_page + 1,
                              page: this.woo_page,
                              orderby: "id",
                              per_page: this.woo_per_page,
                              // status: Array('processing', 'ready-to-dispatch', 'packing', 'picking') // show all post-status array
                              status: "processing,ready-to-dispatch,packing,picking" // show all post-status array
                              // per_page: 10 // gets the number of rec
                              }; 
                          }else{
                            this.request_query = {
                              page: this.woo_page,
                              orderby: "id",
                              per_page: this.woo_per_page,
                              status: "processing,ready-to-dispatch,packing,picking" // show all post-status array
                              // per_page: 10 // gets the number of rec
                              }; 
                          }
                          this.getWooOrders(this.request_query);
                        }


                                // a simple pause to load the log_types
       
       // if for meta or live data.
       
         setTimeout(() => {  
       
         this.systemLogNumbers(this.woo_orders)
          // New seperate
          // this.load_Chart1(this.woo_orders)


        }, 1000);
                       


      //  this.setupOrderCounts(this.woo_orders);
        // this.getActionList(this.action_list_id);
        // this.loadashExamples(this.woo_orders);

        // console.log('Item Data: ' + JSON.stringify(this.item_data));
        // console.log('Woo Orders: ' + JSON.stringify(this.woo_orders));


// Reload Counds
// this.loadCompletedItemsPercentage(this.total_completed_items_percentage, 'chart_guage', 'Total Complete', '180');
// this.loadCompletedItemsPercentage(this.total_cp_items_completed_percentage, 'total_cp_items_completed', 'CP Completed', '120');
//  this.loadCompletedItemsPercentage(this.total_mail_items_completed_percentage, 'total_mail_items_completed', 'MAIL Completed', '120');
//  this.loadCompletedItemsPercentage(this.total_checkout_mail_items_completed_percentage, 'total_checkout_mail_items_completed', 'Woo Checkout Completed', '250');

        }


      }


  ngOnInit(): void {
  //  this.setupOrderCounts(this.woo_orders);
  // this.generateChart();
  
  this.getSystemLogTypes();

  }



generateChart(){

  // reset the counts
  // this.setupOrderCounts(this.woo_orders); // this should load all the guages as well.

  // this.chart = c3.generate({
  //   bindto: '#chart',
  //       data: {
  //           columns: [
  //               ['data1', 30, 200, 100, 400, 150, 250],
  //               ['data2', 50, 20, 10, 40, 15, 25]
  //           ]
  //       }
  //   });







}

setupOrderCounts(sent_data){

  // let data = JSON.parse(sent_data);

  // this.total_ebay_orders = sent_data.reduce((acc, order) => acc += order.total, 0); 
 
  // var totalYears = this.woo_orders.reduce(function (accumulator, pilot) {
  //   return accumulator += pilot.total;
  // }, 0);

  // this.total_orders_dollars = sent_data.reduce((acc, val) => acc ==+ val.total, 0)

 


  // this.total_orders_dollars =  _.sumBy(sent_data, 'total') // using loadash
  // console.log("Total Dollars: $" + this.total_orders_dollars);

  let total: number;

  var output =
  _(this.woo_orders)
    .groupBy('log_id')
    .map((objs: number[], key) => ({
        'log_id': key,
        'total': _.sumBy(objs, "total") }))
    .value();
    //...

    console.log(output);
    this.total_orders_dollars =  _.sumBy(output, 'total')


    const result = _.sumBy(_.values(this.woo_orders), 'total');
    this.total_ebay_orders = result;


    // this.items = new DataManager(sent_data).executeLocal(new Query().take(50));
    this.items = new DataManager(sent_data as JSON[]).executeLocal(new Query().take(100));  //sync fusion local data query
    // this.items = new DataManager(sent_data as JSON[]).executeLocal(new Query().select(['total']).take(100));  //sync fusion local data query
    console.log('Items: ' + JSON.stringify(this.items));

    this.total_orders_dollars = _.sumBy(this.items, 'total') // using loadash



    // turn array of strings into array of numbers
    const arrOfStr = ['1', '2', '3'];
    const arrOfNum = arrOfStr.map(str => {
      return parseInt(str, 10);
    });

    


//array
    // var val = this.woo_orders.reduce(function(previousValue, currentValue) {
    //   return {
    //     // totalProducts: currentValue.total,
    //     totalProducts: previousValue.total + currentValue.total,
    //     // totalShipping: previousValue.children + currentValue.children
    //   }
    // });
    // console.log('val totals:' + JSON.stringify(val));
    // this.new_val = val;


// just get totals and map as number
// var totals = this.woo_orders.map(function (officer: any) {
//   return officer.total as number
// });
// this.total_orders_dollars = _.sumBy(output, 'total') // using loadash

// https://www.tabnine.com/academy/javascript/how-to-get-an-objects-keys-and-values/

// console.log('Getting Object Keys: '  + Object.keys(this.woo_orders[0]));









        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
    


  this.search_results = DataUtil.parse.parseJson(this.woo_orders); // works for meta pass - not direct orders via mysql?
  // this.search_results = this.woo_orders; 

     // if statement to stop errors if woo_ordders and not search results.
  if (this.search_results != '[]' || this.search_results != undefined || this.search_results != Object )  {    
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let count_of_brand_items = Object.keys(this.search_results).length; // this worked for meta data not sql.
  // let count_of_brand_items =this.search_results.length;

  // now loop and push to join model
  this.sent_items_totals_array = [];

  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.search_results[i];
  

      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.sent_items_totals_array.push({
        total: res.log_id[i]
              });

            }
  
  } // end brands loop.





  // All this code just to get the dollar value of the Collection Spent.
  // First make a cvs list 
  // then mapp the follosing
  // Must ge the totals as a CSV List.
  const extractedTotals = this.search_results.map((e) => e.log_id); // putting [] around makes the ouput an array object
  console.log('Extract Totals: ' + extractedTotals)
  // this.total_orders_dollars = _.sum(extractedTotals) // using loadash - this did not work






  
 

  var val = this.sent_items_totals_array.reduce(function(previousValue, currentValue) {
    return {
      // totalProducts: currentValue.total,
      totalProducts: previousValue.total + currentValue.total,
      // totalShipping: previousValue.children + currentValue.children
    }
  });
  console.log('val totals:' + JSON.stringify(val));
  this.new_val = val;



  this.search_results = DataUtil.parse.parseJson(this.woo_orders); 

  // get the shipping cost above .01 -> = CP / Ebay
  let base_value: number = .01
  let findValues_CP = _.find(this.woo_orders, (order : any) => order.shipping_total as number >= 1);
  console.log('FindValues_CP: ' + JSON.stringify(findValues_CP));
 
 
  
this.total_items = Object.keys(this.search_results).length;

// Filter shipping totals greater - remember ruslts must be passed throuh DataUtil first.
let total_completed_data =  this.search_results.filter(function(t) {
  return t.status == 'completed'
  });
  this.total_completed_items = total_completed_data.length;

  this.total_completed_items_percentage = (this.total_completed_items/this.total_items) * (100/1);
  if(this.total_items == 0){
    this.total_completed_items_percentage = (1/1) * (100/1); // prints complete if there are no items to process = 0
    }
  this.loadCompletedItemsPercentage(this.total_completed_items_percentage, 'chart_guage', 'Total Complete', '250');

// Filter shipping totals greater - remember ruslts must be passed throuh DataUtil first.
let cp_data =  this.search_results.filter(function(t) {
return t.shipping_total >= 0.01 && t.created_via == 'Ebay';
});
this.total_cp_items = cp_data.length;

let cp_completed_data =  this.search_results.filter(function(t) {
  return t.shipping_total >= 0.01 && t.created_via == 'Ebay' && t.status == 'completed';
  });

this.total_cp_items_completed = cp_completed_data.length ;
this.total_cp_items_completed_percentage = (this.total_cp_items_completed/this.total_cp_items) * (100/1);
if(this.total_cp_items == 0){
this.total_cp_items_completed_percentage = (1/1) * (100/1); // prints complete if there are no items to process = 0
}
this.loadCompletedItemsPercentage(this.total_cp_items_completed_percentage, 'total_cp_items_completed', 'CP Completed', '120');


let mail_data =  this.search_results.filter(function(t) {
return t.shipping_total < 0.01
});
this.total_mail_items = mail_data.length;


let mail_completed_data =  this.search_results.filter(function(t) {
  return t.shipping_total < 0.01 && t.status == 'completed'
  });
  this.total_mail_items_completed = mail_completed_data.length;
  this.total_mail_items_completed_percentage = (this.total_mail_items_completed/this.total_mail_items) * (100/1);
  if(this.total_mail_items == 0){
    this.total_mail_items_completed_percentage = (1/1) * (100/1); // prints complete if there are no items to process = 0
    }
  this.loadCompletedItemsPercentage(this.total_mail_items_completed_percentage, 'total_mail_items_completed', 'MAIL Completed', '120');




let checkout_mail_data =  this.search_results.filter(function(t) {
return t.created_via == 'checkout';
});
this.total_checkout_mail_items = checkout_mail_data.length;


let checkout_mail_completed_data =  this.search_results.filter(function(t) {
  return t.created_via == 'checkout' && t.status == 'completed';
  });
  this.total_checkout_mail_items_completed = checkout_mail_completed_data.length;

  this.total_checkout_mail_items_completed_percentage = (this.total_checkout_mail_items_completed/this.total_checkout_mail_items) * (100/1);
  if(this.total_checkout_mail_items == 0){
    this.total_checkout_mail_items_completed_percentage = (1/1) * (100/1); // prints complete if there are no items to process = 0
    }
  this.loadCompletedItemsPercentage(this.total_checkout_mail_items_completed_percentage, 'total_checkout_mail_items_completed', 'Woo Checkout Completed', '120');


  // get the sendle, auspost from above,

              //   let checkout_mail_data_sendle = this.search_results.filter(function(t) {
              //     return t.shipping_lines[0].method_id == 'sendle' && t.created_via == 'checkout';
              //     });
              // this.total_checkout_mail_sendle_items = checkout_mail_data_sendle.length;


              // let checkout_mail_completed_data_sendle = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'sendle' && t.created_via == 'checkout'  && t.status == 'completed';
              //   });
              // this.total_checkout_mail_sendle_items_completed = checkout_mail_completed_data_sendle.length;


              // let checkout_mail_data_auspost = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_australia_post' && t.created_via == 'checkout';
              //   });
              // this.total_checkout_mail_auspost_items = checkout_mail_data_auspost.length;

              // let checkout_mail_completed_data_auspost = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_australia_post' && t.created_via == 'checkout' && t.status == 'completed';
              //   });
              // this.total_checkout_mail_auspost_items_completed = checkout_mail_completed_data_auspost.length;


              // let checkout_mail_data_local_pickup = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_australia_post' && t.created_via == 'local_pickup';
              //   });
              // this.total_checkout_mail_local_pickup_items = checkout_mail_data_local_pickup.length;


              // let checkout_mail_completed_data_local_pickup = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_australia_post' && t.created_via == 'local_pickup' && t.status == 'completed';
              //   });
              // this.total_checkout_mail_local_pickup_items_completed = checkout_mail_completed_data_local_pickup.length;


              // let checkout_mail_data_wf_dhl_shipping = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_australia_post' && t.created_via == 'checkout';
              //   });
              // this.total_checkout_mail_wf_dhl_shipping_items = checkout_mail_data_wf_dhl_shipping.length;


              // let checkout_mail_completed_data_wf_dhl_shipping = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_australia_post' && t.created_via == 'checkout' && t.status == 'completed';
              //   });
              // this.total_checkout_mail_wf_dhl_shipping_items_completed = checkout_mail_completed_data_wf_dhl_shipping.length;


              // let checkout_mail_data_wf_fedex_woocommerce_shipping = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_fedex_woocommerce_shipping' && t.created_via == 'checkout';
              //   });
              // this.total_checkout_mail_wf_fedex_woocommerce_shipping_items = checkout_mail_data_wf_fedex_woocommerce_shipping.length;

              // let checkout_mail_completed_data_wf_fedex_woocommerce_shipping = this.search_results.filter(function(t) {
              //   return t.shipping_lines[0].method_id == 'wf_fedex_woocommerce_shipping' && t.created_via == 'checkout' && t.status == 'completed';
              //   });
              // this.total_checkout_mail_wf_fedex_woocommerce_shipping_completed = checkout_mail_completed_data_wf_fedex_woocommerce_shipping.length;


//totals
// @@ wju tthe + "" makes a string // @https://stackoverflow.com/questions/10145946/what-is-causing-the-error-string-split-is-not-a-function
let string = this.search_results.map((e) => e.total)+ '';
// var string = "5000,5000,2500.00";
var nums = string.split(",");
var sum = 0;

nums.forEach(function (number) {
    sum += parseFloat(number);
});

let round_sum = _.round(sum, 2);
this.total_orders_dollars = round_sum
//...
// @@ wju tthe + "" makes a string // @https://stackoverflow.com/questions/10145946/what-is-causing-the-error-string-split-is-not-a-function
let string_shipping_costs = this.search_results.map((e) => e.shipping_total)+ '';
// var string = "5000,5000,2500.00";
var nums = string_shipping_costs.split(",");
var sum = 0;

nums.forEach(function (number) {
    sum += parseFloat(number);
});

let round_shipping_costs = _.round(sum, 2);
this.total_shipping_dollars = round_shipping_costs
//...


let round_tototal_profits = _.round(sum, 2);
this.total_profit_dollars = _.round(this.total_orders_dollars - this.total_shipping_dollars, 2);

  }
  //...



  loadCompletedItemsPercentage(percentage, guage, name, height){
    this.chart_guage = c3.generate({
      bindto: '#' + guage,
      data: {
          columns: [
              [name, percentage]
          ],
          type: 'gauge',
          onclick: function (d, i) { console.log("onclick", d, i); },
          onmouseover: function (d, i) { console.log("onmouseover", d, i); },
          onmouseout: function (d, i) { console.log("onmouseout", d, i); }
      },
      gauge: {
  //        label: {
  //            format: function(value, ratio) {
  //                return value;
  //            },
  //            show: false // to turn off the min/max labels.
  //        },
  //    min: 0, // 0 is default, //can handle negative min e.g. vacuum / voltage / current flow / rate of change
  //    max: 100, // 100 is default
  //    units: ' %',
  //    width: 39 // for adjusting arc thickness
      },
      color: {
          pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'], // the three color levels for the percentage values.
          threshold: {
  //            unit: 'value', // percentage is default
  //            max: 200, // 100 is default
              values: [30, 60, 90, 100]
          }
      },
      size: {
          height: height
      }
  });

 




  }






loadashExamples(send_data){

  this.movieExist = !!_.find(this.movies, { name: 'Batman Begins' });
  this.movieNotExist = !!_.find(this.movies, { name: 'ABABAB' });
  // Also possible to filter array object by find
  const findValue = _.find(this.movies, (movie) => movie.rating = 7.1);

  // lodash times
  console.log(_.times(3, String)); //  ['0', '1', '2']
  console.log(_.times(2, _.constant('edupala')));['edupala', 'edupala']

  //Lodash Sets the value at path of object. No path
  // in our case add Bootstrap at end of names array
  _.set(this.names, '4', 'Bootstrap');
  console.log(this.names);

  // Lodash clone function
  const copy = _.cloneDeep(this.movies);
  console.log('This copy method of lodash : ' + copy);

  // Lodash sortedUniq remove duplicate and sort
  console.log('Sort and remove duplicate', _.sortedUniq(this.sortedNums));

  // Lodash debouce // delay calling 5000 second -- this is pretty cool.
//  _.debounce(this.callMethods, 5000)();

}



systemLogNumbers(send_data){
 

  this.search_results = this.woo_orders; // works for meta pass - not direct orders via mysql?


  this.graph_data = new DataManager(this.search_results as JSON[]).executeLocal(new Query()); // Sets the grid data for the graphs //.take(100)

  this.search_results_clone_START = this.woo_orders; // works for meta pass - not direct orders via mysql?



  this.moviesByRating = _.filter(send_data, (movie) => movie.log_type_id > 5);
  this.user_login_count = this.moviesByRating.length;

  this.user_logout = _.filter(send_data, (movie) => movie.log_type_id > 30);
  this.user_logout_count = this.user_logout.length;

  this.user_forced_logout_ON = _.filter(send_data, (movie) => movie.log_type_id > 28);
  this.user_forced_logout_ON_count = this.user_forced_logout_ON.length;

  this.user_forced_logout_OFF = _.filter(send_data, (movie) => movie.log_type_id > 29);
  this.user_forced_logout_OFF_count = this.user_forced_logout_OFF.length;

  // let count_of_items =  this.system_log_types.length
  //                   // let newArr = this.payment_item_model.filter((sbi)=>(1===1));
  //                 // let count_of_items = this.payment_item_model.length;
  //                 for(let i=0;i < count_of_items; i++) {
  //                   let log_types_res = this.system_log_types[i];
  //                   // get a count and set a variable or push to array... ???
                    
  //                   // this.lookupInvoiceUpdateInvoice2(this.payment_item_model.myob_id, data);
  //                 }
let arr =  this.search_results;
// console.log('System_log_Types' + JSON.stringify(this.system_log_types));
                  const result2 = _.map(
                    _.groupBy(arr, 'log_type_id'),
                   items => ({
                    ...items[0].log_type_id,
                    count: items.length
                   })
                  )
                  
                  console.log('Count Resutl:' + JSON.stringify(result2));




 // using the identity method
let b = _.countBy(arr, 'log_type_name');
console.log('b: ' + JSON.stringify(b));

let mapped_b_numbers = _.map(b, 'log_type_name');
let mapped_b_labels = _.map(b, 'count');
this.log_types_mapped_numbers = mapped_b_numbers;
this.log_types_mapped_labels = mapped_b_labels;









// var data = [
//   {"cat":"IT","company":"Apple", "price":"100.5"},
//   {"cat":"IT","company":"Apple", "price":"100"},
//   {"cat":"IT","company":"Google", "price": "100"},
//   {"cat":"IT","company":"Apple", "price": "100"}
//  ];
//  var group = _.groupBy(data, 'company')
 var group = _.groupBy(this.search_results, 'log_type_name')
 
 var result00 = _.map(_.keys(group), function(e) {
   return _.reduce(group[e], function(r, o) {
    //  return r.count += +o.log_id, r
     return  r
  }, {log_type_name: e, sum: group[e].length, color: ""})
 })
 
 console.log(result00);


 let add_clients_data =  this.search_results.filter(function(t) {
  return t.brand_type_id == '3';
  });
  var client_group = _.groupBy(add_clients_data, 'log_type_name')
  var result00_client = _.map(_.keys(client_group), function(e) {
    return _.reduce(client_group[e], function(r, o) {
     //  return r.count += +o.log_id, r
      return  r
   }, 
   {log_type_name: e, sum: client_group[e].length, color: "purple"}
   )
  })

  let add_agents_data =  this.search_results.filter(function(t) {
    return t.brand_type_id == '2';
    });
    var agent_group = _.groupBy(add_agents_data, 'log_type_name')
    var result00_agent = _.map(_.keys(agent_group), function(e) {
      return _.reduce(agent_group[e], function(r, o) {
       //  return r.count += +o.log_id, r
        return  r
     }, 
     {log_type_name: e, sum: agent_group[e].length, color: "tomato"}
     )
    })

    let add_staff_data =  this.search_results.filter(function(t) {
      return t.brand_type_id == '1';
      });
      var staff_group = _.groupBy(add_staff_data, 'log_type_name')
      var result00_staff = _.map(_.keys(staff_group), function(e) {
        return _.reduce(staff_group[e], function(r, o) {
         //  return r.count += +o.log_id, r
          return  r
       }, 
       {log_type_name: e, sum: staff_group[e].length, color: "DodgerBlue"}
       )
      })



      // let add_Chart2_users_data =  this.search_results.filter(function(t) {
      //   return t.who_created == send_data.who_created;
      //   });
      //   var Chart2_users_group = _.groupBy(add_Chart2_users_data, 'log_type_name')
      //   var result00_Chart2_users = _.map(_.keys(Chart2_users_group), function(e) {
       
      //     return _.reduce(Chart2_users_group[e], function(r, o) {
      //      //  return r.count += +o.log_id, r
      //       return  r
      //    }, 
      //   //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "green"}
      //   // {created_date: Chart2_users_group[e]["created_date"], sum: e , color: "green"}
      //   {created_date: add_Chart2_users_data, sum: e , color: "green"}
 

      //    )
      //   })


        // var Chart2_users_group = _.groupBy(this.search_results, 'log_type_name')
        var Chart2_users_group = this.search_results;
        
        var result00_Chart2_users_group = _.map(_.keys(Chart2_users_group), function(e) {
          return _.reduce(Chart2_users_group[e], function(r, o) {
           //  return r.count += +o.log_id, r
            return r
         },
        //  2023-05-20T12:44:00+1000
        //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
        //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
         {log_type_name: Chart2_users_group[e].created_level, sum: Chart2_users_group[e].length, color: "yellow", created_date: this.legalDate.toAuditDate(Chart2_users_group[e].created_date) ?? new Date(Chart2_users_group[e].created_date)})
        })


        this.Chart2_title = 'Created Level Vs Time Track'
        this.Chart2_marker = { visible: true, width: 10, height: 10, shape: "Rectangle" };
        this.Chart2_tooltip = {
          enable: true,
          template: this.Chart2_tooltipTemplate
        };


        // Chart 3 - Events Categories Over Time.
        var Chart3_users_group = this.search_results;
        
        var result00_Chart3_users_group = _.map(_.keys(Chart3_users_group), function(e) {
          return _.reduce(Chart3_users_group[e], function(r, o) {
           //  return r.count += +o.log_id, r
            return r
         },
        //  2023-05-20T12:44:00+1000
        //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
        //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
         {log_type_name: Chart3_users_group[e].log_type_id, sum: Chart3_users_group[e].length, color: "navy", created_date: this.legalDate.toAuditDate(Chart3_users_group[e].created_date) ?? new Date(Chart3_users_group[e].created_date)})
        })


        this.Chart3_title = 'Log TypeID Vs Time Track'
        this.Chart3_marker = { visible: true, width: 10, height: 10, shape: "Triangle" };
        this.Chart3_tooltip = {
          enable: true,
          template: this.Chart3_tooltipTemplate
        };

      this.Chart3_tooltipTemplate = "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";



        // Load all charts

  this.chartData = result00;
  this.chartData_client = result00_client;
  this.chartData_agent = result00_agent;
  this.chartData_staff = result00_staff;
  this.Chart2_users_data = result00_Chart2_users_group;
  this.Chart3_all_data = result00_Chart3_users_group;


// this.chartData = [
//   { month: 'Jan', sales: 35 }, { month: 'Feb', sales: 28 },
//   { month: 'Mar', sales: 34 }, { month: 'Apr', sales: 32 },
//   { month: 'May', sales: 40 }, { month: 'Jun', sales: 32 },
//   { month: 'Jul', sales: 35 }, { month: 'Aug', sales: 55 },
//   { month: 'Sep', sales: 38 }, { month: 'Oct', sales: 30 },
//   { month: 'Nov', sales: 25 }, { month: 'Dec', sales: 32 }
// ];
this.primaryXAxis = {
  valueType: 'Category',
  title: 'Event Types'
};
// this.title = 'All Log Events';
this.tooltip = { enable: true };
this.marker = { visible: true, width: 10, height: 10 };
this.title = 'Investigation Events: 1975-2010';
this.chartArea = {
  border: {
      width: 0
  }
};
this.cornerRadius = {
  topLeft: 10, topRight: 10
};
this.pointColorMapping = "color";
this.animation = { enable: true};





var countBy = (obj, func) => {
  var counts = {};
  var arr = Object.keys(obj);
  arr.forEach((sourceKey, i, arr) => {
      var el = obj[sourceKey];
      var key = func.call(obj, el, sourceKey, obj);
      counts[key] = counts[key] === undefined ? 1 : counts[key] += 1;
  });
  return counts;
};

// let arr = [{
//       username: 'john',
//       score: 37
//   }, {
//       username: 'jake',
//       score: 67
//   }, {
//       username: 'bill',
//       score: 20
//   }
// ];

console.log(countBy(arr, function (el) {
      return el.score >= 65 ? 'pass' : 'fail';
  }));




  var result = this.search_results.reduce(function(r, o) {
    if (r[o.log_type_id]){
        ++r[o.log_type_id].count;
        // r[o.company].price += Number(o.price);
    } else {
        // r[o.company] = {count: 1, price: Number(o.price)};
    }
    return r;
}, {});

console.log('r' + JSON.stringify(result));

}


export() {
  this.chart.exportModule.export('PDF', 'SO_ActionListChartA_' + this.action_day_words, 1,[this.chart]);
}


add_clients() {

// Filter shipping totals greater - remember ruslts must be passed throuh DataUtil first.
let add_clients_data =  this.search_results.filter(function(t) {
  return t.brand_type_id == '3';
  });
  // Now 
  var group = _.groupBy(add_clients_data, 'log_type_name')
 
  var result00 = _.map(_.keys(group), function(e) {
    return _.reduce(group[e], function(r, o) {
     //  return r.count += +o.log_id, r
      return  r
   }, {log_type_name: e, sum: group[e].length, color: "purple"})
  })

  this.chart.addSeries([{
  type: 'Bar',
  dataSource: result00,
//   dataSource: [{ x: 'John', y: 11000 }, { x: 'Jake', y: 16000 }, { x: 'Peter', y: 19000 },
//   { x: 'James', y: 12000 }, { x: 'Mary', y: 10700 }],
  xName: 'x', width: 2,
  yName: 'y',
  
}]);

}
remove_clients() {
this.chart.removeSeries(1);
}





//Lodash filter function
findMoviesByRating(rating: number): void {
  this.moviesByRating = _.filter(this.movies, (movie) => movie.rating > rating);
}

//Lodash pull to remove item from array
removeItem(item: string): void {
  this.names = _.pull(this.names, item);
  console.log(this.names);
}

// Lodash sort
sortAscendingMovies() {
  this.movies = _.sortBy(this.movies, 'name');
}

// Lodash reverse
sortDescendingMovies() {
  this.movies = _.sortBy(this.movies, 'name').reverse();
}

callMethods(): void {
  alert('Call after 5 second');
}


getSystemLogTypes() {
  this._demoService.getSystemLogTypes().subscribe(
     data2 => { this.system_log_types = data2;
      // console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }





    // request_query
    getWooOrders(request_query){
  //     if(this.grid){this.grid.showSpinner();}
  // this.orderService.listAllOrders(request_query).subscribe(response => {
  //   console.log(response);
  //   this.woo_orders = response
  //  // this.refreshGrid();
  //  this.setupOrderCounts(this.woo_orders);
  //  // this.getActionList(this.action_list_id);
  //  this.loadashExamples(this.woo_orders);


  //  if(this.grid){this.grid.hideSpinner();}
  // }, (err) => {
  //   console.log('ngx:woo:error ', err);
  // });
    }


    load_Chart1(send_data){

      this.search_results = send_data; // works for meta pass - not direct orders via mysql?
      // DataUtil.parse.parseJson(this.search_results); // if we need to. // this may be the dates errors/
      this.search_results_clone = this.search_results;
              this.search_results_clone_START = send_data; // works for meta pass - not direct orders via mysql? DataUtil.parse.parseJson()


        this.graph_data = new DataManager(this.search_results_clone as JSON[]).executeLocal(new Query()); // Sets the grid data for the graphs //.take(100)
      

      
        this.moviesByRating = _.filter(send_data, (movie) => movie.log_type_id > 5);
        this.user_login_count = this.moviesByRating.length;
      
        this.user_logout = _.filter(send_data, (movie) => movie.log_type_id > 30);
        this.user_logout_count = this.user_logout.length;
      
        this.user_forced_logout_ON = _.filter(send_data, (movie) => movie.log_type_id > 28);
        this.user_forced_logout_ON_count = this.user_forced_logout_ON.length;
      
        this.user_forced_logout_OFF = _.filter(send_data, (movie) => movie.log_type_id > 29);
        this.user_forced_logout_OFF_count = this.user_forced_logout_OFF.length;


// var data = [
//   {"cat":"IT","company":"Apple", "price":"100.5"},
//   {"cat":"IT","company":"Apple", "price":"100"},
//   {"cat":"IT","company":"Google", "price": "100"},
//   {"cat":"IT","company":"Apple", "price": "100"}
//  ];
//  var group = _.groupBy(data, 'company')
var group = _.groupBy(this.search_results_clone, 'log_type_name')

          var result00 = _.map(_.keys(group), function(e) {
          return _.reduce(group[e], function(r, o) {
          //  return r.count += +o.log_id, r
          return  r
          }, {log_type_name: e, sum: group[e].length, color: ""})
          })

          // console.log(result00);


          let add_clients_data =  this.search_results_clone.filter(function(t) {
          return t.brand_type_id == '3';
          });
          var client_group = _.groupBy(add_clients_data, 'log_type_name')
          var result00_client = _.map(_.keys(client_group), function(e) {
          return _.reduce(client_group[e], function(r, o) {
          //  return r.count += +o.log_id, r
          return  r
          }, 
          {log_type_name: e, sum: client_group[e].length, color: "purple"}
          )
          })

          let add_agents_data =  this.search_results_clone.filter(function(t) {
          return t.brand_type_id == '2';
          });
          var agent_group = _.groupBy(add_agents_data, 'log_type_name')
          var result00_agent = _.map(_.keys(agent_group), function(e) {
          return _.reduce(agent_group[e], function(r, o) {
          //  return r.count += +o.log_id, r
          return  r
          }, 
          {log_type_name: e, sum: agent_group[e].length, color: "tomato"}
          )
          })

          let add_staff_data =  this.search_results_clone.filter(function(t) {
          return t.brand_type_id == '1';
          });
          var staff_group = _.groupBy(add_staff_data, 'log_type_name')
          var result00_staff = _.map(_.keys(staff_group), function(e) {
          return _.reduce(staff_group[e], function(r, o) {
          //  return r.count += +o.log_id, r
          return  r
          }, 
          {log_type_name: e, sum: staff_group[e].length, color: "DodgerBlue"}
          )
          })




          // Set Charts
          this.chartData = result00;
          this.chartData_client = result00_client;
          this.chartData_agent = result00_agent;
          this.chartData_staff = result00_staff;

      
    }



}
